import { useCallback, useRef, useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function useOpenScan() {
    const history = useHistory();
    const { pathname, search } = useLocation();
    const openScanId = new URLSearchParams(search).get('open') || null;

    // Track latest search in a ref so callbacks don't recreate on every search change
    const searchRef = useRef(search);
    useLayoutEffect(() => {
        searchRef.current = search;
    });

    const open = useCallback(
        (id) => {
            const p = new URLSearchParams(searchRef.current);
            p.set('open', id);
            history.replace(`${pathname}?${p.toString()}`);
        },
        [history, pathname],
    );

    const close = useCallback(() => {
        const p = new URLSearchParams(searchRef.current);
        p.delete('open');
        const qs = p.toString();
        history.replace(qs ? `${pathname}?${qs}` : pathname);
    }, [history, pathname]);

    return { openScanId, open, close };
}
